"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualVehicleEditorWidget = void 0;
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var services_1 = require("@falcon/services");
var core_1 = require("@athena-portal/core");
var moment = require("moment");
var rxjs_1 = require("rxjs");
var FalconQuestionWidgetBase_1 = require("../../FalconQuestionWidgetBase");
var journey_services_1 = require("@athena-portal/journey-services");
var commonFunctions_1 = require("../../../commonFunctions");
var React = require("react");
var AnnualVehicleEditorWidget = exports.AnnualVehicleEditorWidget = /** @class */ (function (_super) {
    __extends(AnnualVehicleEditorWidget, _super);
    function AnnualVehicleEditorWidget(props) {
        var _a;
        var _this = this;
        var _b, _c, _d, _e;
        _this = _super.call(this, props) || this;
        _this.IS_VALID = "is-valid";
        _this.IS_INVALID = "is-invalid";
        _this.MODEL_EVENT_ID = "VehicleModelLookupWidget-fullVehicleModelYear-load";
        _this.TRANSMISSION_EVENT_ID = "VehicleModelLookupWidget-selectedVehicleTransmission-load";
        _this.FUEL_TYPE_EVENT_ID = "VehicleModelLookupWidget-selectedVehicleFuelType-load";
        _this.DOORS_EVENT_ID = "VehicleModelLookupWidget-doors-load";
        _this.SHORTENED_MODEL_EVENT_ID = "VehicleModelLookupWidget-shortenedModel-load";
        props.engine.toggleOverlay(true, _this.MODEL_EVENT_ID);
        props.engine.toggleOverlay(true, _this.TRANSMISSION_EVENT_ID);
        props.engine.toggleOverlay(true, _this.FUEL_TYPE_EVENT_ID);
        props.engine.toggleOverlay(true, _this.DOORS_EVENT_ID);
        props.engine.toggleOverlay(true, _this.SHORTENED_MODEL_EVENT_ID);
        _this.carDetailsPage = _this.getSetting("carDetailsPage", undefined);
        var interactionVehicleValue;
        _this.interactionVehicleSetting = _this.getSetting("interactionVehicle", undefined);
        if (_this.interactionVehicleSetting) {
            interactionVehicleValue = journey_services_1.ObjectManipulator.fetchFieldValue(_this.interactionVehicleSetting, _this.props.interaction);
            _this.interactionVehicle = interactionVehicleValue;
        }
        else {
            throw Error("".concat(_this.props.question.type, " widget is missing 'interactionVehicle' setting"));
        }
        var vehicleManufacturer = interactionVehicleValue.make;
        var vehicleModel = interactionVehicleValue.model;
        if (((_b = _this.props.interaction.uistate) === null || _b === void 0 ? void 0 : _b.minCarYear) && ((_c = _this.props.interaction.uistate) === null || _c === void 0 ? void 0 : _c.maxCarYear)) {
            vehicleModel = interactionVehicleValue.model + " (" + ((_d = _this.props.interaction.uistate) === null || _d === void 0 ? void 0 : _d.minCarYear) + " - " + ((_e = _this.props.interaction.uistate) === null || _e === void 0 ? void 0 : _e.maxCarYear) + ")";
        }
        var vehicleModelYear = interactionVehicleValue.year;
        _this.vehiclePurchaseDate = interactionVehicleValue.purchaseDate;
        var vehicleTransmission = interactionVehicleValue.transmission;
        var vehicleFuelType = (0, commonFunctions_1.getInteractionVehicleFuelType)(interactionVehicleValue.fuelType, interactionVehicleValue.fuelTypeFull);
        var hasNotBeenBoughtValue = interactionVehicleValue.hasNotBeenBought;
        var selectedDoors = interactionVehicleValue.doors;
        var shortenedModel = interactionVehicleValue.shortenedModel;
        _this.carDetailsPage = _this.getSetting("carDetailsPage", undefined);
        if (!_this.carDetailsPage) {
            throw Error("".concat(_this.props.question.type, " widget is missing 'carDetailsPage' setting"));
        }
        var fullVehicleManufacturer = vehicleManufacturer ? vehicleManufacturer : null;
        var fullVehicleModel = vehicleModel ? vehicleModel : null;
        var fullVehicleShortenedModel = shortenedModel ? shortenedModel : null;
        var fullVehicleModelYear = vehicleModelYear ? vehicleModelYear : null;
        var purchaseDateMonth = _this.vehiclePurchaseDate ? moment(_this.vehiclePurchaseDate).format("MM") : null;
        var purchaseDateYear = _this.vehiclePurchaseDate ? moment(_this.vehiclePurchaseDate).format("YYYY") : null;
        var fullVehiclePurchaseDate = _this.vehiclePurchaseDate ? "".concat(purchaseDateYear, "-").concat(purchaseDateMonth, "-01") : null;
        var selectedVehicleTransmission = vehicleTransmission ? vehicleTransmission : null;
        var selectedVehicleFuelType = vehicleFuelType ? vehicleFuelType : null;
        var hasNotBeenBoughtState = hasNotBeenBoughtValue ? hasNotBeenBoughtValue : false;
        _this.state = {
            // "Make" input field state
            fullVehicleManufacturer: fullVehicleManufacturer,
            vehicleManufacturerList: [],
            manufacturerValid: "",
            manufacturerFound: "",
            manufacturerLoading: false,
            // "Car model" (short model) input field state
            fullVehicleShortenedModel: fullVehicleShortenedModel,
            vehicleShortenedModelList: [],
            shortenedModelValid: "",
            shortenedModelFound: "",
            shortenedModelReadOnly: false,
            // "Year of manufacture" input field state
            fullVehicleModelYear: fullVehicleModelYear,
            vehicleModelYears: [],
            modelYearValid: "",
            modelYearReadOnly: false,
            modelYearLoading: false,
            // "Date of purchase" input field state
            purchaseDateMonth: purchaseDateMonth,
            purchaseDateYear: purchaseDateYear,
            purchaseMonthValid: "",
            purchaseYearValid: "",
            fullVehiclePurchaseDate: fullVehiclePurchaseDate,
            hasNotBeenBought: hasNotBeenBoughtState,
            // "Transmission" input field state
            vehicleTransmissions: [],
            selectedVehicleTransmission: selectedVehicleTransmission,
            transmissionValid: "",
            // "Fuel Type" input field state
            vehicleFuelTypes: [],
            fuelTypeValid: "",
            selectedVehicleFuelType: selectedVehicleFuelType,
            // "Number of doors" input field state
            doors: [],
            selectedDoors: selectedDoors,
            doorsValid: "",
            // "Select the Car" input field state
            modelValid: "",
            modelFound: "",
            modelLoading: false,
            modelReadOnly: true,
            fullVehicleModel: fullVehicleModel,
            vehicleModelList: [],
            // other state fields
            typingTimeout: 0,
            subscription: rxjs_1.Subscription.EMPTY,
        };
        _this.props.engine.setJourneyState((_a = {}, _a["hidePageValidationErrorMessage"] = false, _a));
        _this.handleManufacturerChange = _this.handleManufacturerChange.bind(_this);
        _this.handleModelChange = _this.handleModelChange.bind(_this);
        _this.handleShortenedModelChange = _this.handleShortenedModelChange.bind(_this);
        _this.handleModelYearChange = _this.handleModelYearChange.bind(_this);
        _this.handleOnPurchaseMonthChange = _this.handleOnPurchaseMonthChange.bind(_this);
        _this.handleOnPurchaseYearChange = _this.handleOnPurchaseYearChange.bind(_this);
        _this.handleOnCheckboxChange = _this.handleOnCheckboxChange.bind(_this);
        _this.bindPurchaseDateToField = _this.bindPurchaseDateToField.bind(_this);
        _this.allFieldsFilled = _this.allFieldsFilled.bind(_this);
        _this.navigate = _this.navigate.bind(_this);
        _this.loadModelsOnFirstClick = _this.loadModelsOnFirstClick.bind(_this);
        _this.loadShortenedModelsOnFirstClick = _this.loadShortenedModelsOnFirstClick.bind(_this);
        _this.logError = _this.logError.bind(_this);
        _this.onSelectNumberOfDoors = _this.onSelectNumberOfDoors.bind(_this);
        _this.onSelectVehicleTransmission = _this.onSelectVehicleTransmission.bind(_this);
        _this.onSelectVehicleFuelType = _this.onSelectVehicleFuelType.bind(_this);
        _this.onSelectVehicleManufacturer = _this.onSelectVehicleManufacturer.bind(_this);
        _this.onSelectVehicleModel = _this.onSelectVehicleModel.bind(_this);
        _this.onSelectVehicleShortenedModel = _this.onSelectVehicleShortenedModel.bind(_this);
        _this.onKeyPressVehicleManufacturer = _this.onKeyPressVehicleManufacturer.bind(_this);
        _this.onKeyPressVehicleModel = _this.onKeyPressVehicleModel.bind(_this);
        _this.findVehicleManufacturer(false);
        _this.findVehicleShortenedModels(false);
        _this.findVehicleModelYear(fullVehicleManufacturer, fullVehicleShortenedModel, false);
        _this.findVehicleTransmissions(fullVehicleManufacturer, fullVehicleShortenedModel, parseInt(fullVehicleModelYear, 10), false);
        _this.findVehicleFuelTypes(fullVehicleManufacturer, fullVehicleShortenedModel, parseInt(fullVehicleModelYear, 10), selectedVehicleTransmission, false);
        _this.findVehicleNumberOfDoors(fullVehicleManufacturer, fullVehicleShortenedModel, parseInt(fullVehicleModelYear, 10), selectedVehicleTransmission, selectedVehicleFuelType);
        _this.findVehicleModel(false);
        return _this;
    }
    AnnualVehicleEditorWidget.prototype.componentDidCatch = function (error, errorInfo) {
        this.logError(error, errorInfo);
    };
    AnnualVehicleEditorWidget.prototype.componentDidMount = function () {
        if (this.getSetting("validatePurchaseDateOnMount", false)) {
            this.bindPurchaseDateToField();
        }
    };
    AnnualVehicleEditorWidget.prototype.isChecked = function () {
        var value = this.bindFromField(this.props.interaction.vehicles[0].hasNotBeenBought);
        return value === true || value === "true" || false;
    };
    AnnualVehicleEditorWidget.prototype.renderInputField = function () {
        return (React.createElement(React.Fragment, null,
            this.renderVehicleManufacturers(),
            React.createElement("br", null),
            this.renderVehicleShortenedModelQuestion(),
            this.renderVehicleManufactureYears(),
            this.renderVehiclePurchaseDate(),
            this.renderTransmissionRadioButtons(),
            this.renderFuelTypeRadioButtons(),
            this.renderNumberOfDoors(),
            this.renderVehicleModelQuestion(),
            this.allFieldsFilled() &&
                React.createElement("div", { className: "d-flex w-100 justify-content-center my-2 btn-container" },
                    React.createElement("button", { disabled: !this.allFieldsFilled(), onClick: this.navigate, className: "btn btn-white btn-center-edit-car-details", type: "button", tabIndex: 0 }, "All done"))));
    };
    AnnualVehicleEditorWidget.prototype.findVehicleManufacturer = function (update) {
        var _this = this;
        if (update === void 0) { update = true; }
        if (this.state.fullVehicleManufacturer) {
            if (update) {
                this.state.subscription.unsubscribe();
                var subscription = this.falconConvenienceApiService.getVehicleManufacturerDetails(this.state.fullVehicleManufacturer)
                    .subscribe(function (output) {
                    _this.setState({
                        vehicleManufacturerList: output,
                        fullVehicleModel: '',
                        fullVehicleModelYear: '',
                        modelValid: "",
                        modelYearValid: "",
                        manufacturerFound: output.length > 0 ? _this.IS_VALID : _this.IS_INVALID,
                        manufacturerLoading: false
                    });
                }, function () {
                    _this.logError(new Error("Convenience API error(getVehicleManufacturerDetails)"));
                    _this.setState({
                        manufacturerLoading: false
                    });
                });
                this.setState({
                    subscription: subscription
                });
            }
            else {
                this.setState({
                    vehicleManufacturerList: [],
                    manufacturerValid: this.IS_VALID
                });
            }
            this.setState({
                manufacturerLoading: update
            });
        }
    };
    AnnualVehicleEditorWidget.prototype.loadModelsOnFirstClick = function (event) {
        if (!this.state.fullVehicleModel && this.state.fullVehicleManufacturer && this.state.fullVehicleShortenedModel) {
            this.callVehicleModelService(false, this.state.fullVehicleManufacturer, "");
        }
    };
    AnnualVehicleEditorWidget.prototype.loadShortenedModelsOnFirstClick = function (event) {
        if (!this.state.fullVehicleShortenedModel && this.state.fullVehicleManufacturer) {
            this.findVehicleShortenedModels(true);
        }
    };
    AnnualVehicleEditorWidget.prototype.findVehicleModel = function (update) {
        if (update === void 0) { update = true; }
        if (this.state.fullVehicleManufacturer) {
            if (update) {
                var modelSearchString = this.state.fullVehicleModel ? this.state.fullVehicleModel : "";
                this.callVehicleModelService(update, this.state.fullVehicleManufacturer, modelSearchString);
            }
            else {
                this.setState({
                    vehicleModelList: [],
                    vehicleShortenedModelList: [],
                    modelReadOnly: false,
                    modelValid: this.IS_VALID
                });
            }
            this.setState({
                modelLoading: update
            });
        }
    };
    AnnualVehicleEditorWidget.prototype.findVehicleModelYear = function (manufacturer, shortModel, update) {
        var _this = this;
        if (update === void 0) { update = true; }
        if (manufacturer) {
            this.state.subscription.unsubscribe();
            var sub = this.falconConvenienceApiService.getVehicleModelYears(manufacturer, shortModel)
                .subscribe(function (output) {
                _this.setState({
                    modelYearLoading: false,
                    vehicleModelYears: output
                });
                if (update) {
                    _this.setState({
                        fullVehicleModelYear: ''
                    });
                }
                else {
                    _this.setState({
                        modelYearReadOnly: output.length === 0,
                        modelYearValid: output.length > 0 ? _this.IS_VALID : _this.IS_INVALID
                    });
                }
                _this.props.engine.toggleOverlay(false, _this.MODEL_EVENT_ID);
            }, function () {
                _this.props.engine.toggleOverlay(false, _this.MODEL_EVENT_ID);
                _this.logError(new Error("Convenience API error(getVehicleModelYears)"));
                _this.setState({
                    modelYearLoading: false
                });
            });
            this.setState({
                subscription: sub,
                modelYearLoading: true
            });
        }
        else {
            this.props.engine.toggleOverlay(false, this.MODEL_EVENT_ID);
        }
    };
    AnnualVehicleEditorWidget.prototype.findVehicleTransmissions = function (manufacturer, shortenedModel, year, update) {
        var _this = this;
        if (update === void 0) { update = true; }
        if (manufacturer && year) {
            this.state.subscription.unsubscribe();
            var sub = this.falconConvenienceApiService.getVehicleTransmissions(manufacturer, year, shortenedModel)
                .subscribe(function (output) {
                var vehicleTransmissions = output;
                _this.setState({
                    vehicleTransmissions: vehicleTransmissions
                });
                _this.props.engine.toggleOverlay(false, _this.TRANSMISSION_EVENT_ID);
            }, function () {
                _this.props.engine.toggleOverlay(false, _this.TRANSMISSION_EVENT_ID);
                _this.logError(new Error("Convenience API error(getVehicleTransmissions)"));
            });
            this.setState({
                subscription: sub
            });
        }
        else {
            this.props.engine.toggleOverlay(false, this.TRANSMISSION_EVENT_ID);
        }
    };
    AnnualVehicleEditorWidget.prototype.findVehicleFuelTypes = function (manufacturer, shortenedModel, year, transmission, update) {
        var _this = this;
        if (update === void 0) { update = true; }
        if (manufacturer && year && transmission) {
            this.state.subscription.unsubscribe();
            var sub = this.falconConvenienceApiService.getVehicleFuelTypes(manufacturer, year, transmission, shortenedModel)
                .subscribe(function (output) {
                var vehicleFuelTypes = output;
                _this.setState({
                    vehicleFuelTypes: vehicleFuelTypes
                });
                if (!update) {
                    _this.setState({
                        modelReadOnly: false
                    });
                }
                _this.props.engine.toggleOverlay(false, _this.FUEL_TYPE_EVENT_ID);
            });
            this.setState({
                subscription: sub
            });
        }
        else {
            this.props.engine.toggleOverlay(false, this.FUEL_TYPE_EVENT_ID);
        }
    };
    AnnualVehicleEditorWidget.prototype.findVehicleNumberOfDoors = function (manufacturer, shortenedModel, year, transmission, fuelType) {
        var _this = this;
        if (manufacturer && year && transmission && fuelType) {
            this.state.subscription.unsubscribe();
            var sub = this.falconConvenienceApiService.getVehicleDoors(manufacturer, year, transmission, fuelType, null, shortenedModel)
                .subscribe(function (output) {
                _this.setState({
                    doors: output
                });
                _this.props.engine.toggleOverlay(false, _this.DOORS_EVENT_ID);
            });
            this.setState({
                subscription: sub
            });
        }
        else {
            this.props.engine.toggleOverlay(false, this.DOORS_EVENT_ID);
        }
    };
    AnnualVehicleEditorWidget.prototype.findVehicleShortenedModels = function (update) {
        var _this = this;
        var manufacturer = this.state.fullVehicleManufacturer ? this.state.fullVehicleManufacturer : "";
        var shortenedModel = this.state.fullVehicleShortenedModel ? this.state.fullVehicleShortenedModel : "";
        if (manufacturer) {
            this.state.subscription.unsubscribe();
            if (update) {
                var sub = this.falconConvenienceApiService.getAnnualVehicleShortenedModelDetails(manufacturer, shortenedModel)
                    .subscribe(function (output) {
                    _this.setState({
                        vehicleShortenedModelList: output,
                        shortenedModelFound: output.length > 0 ? _this.IS_VALID : _this.IS_INVALID,
                    });
                    _this.props.engine.toggleOverlay(false, _this.SHORTENED_MODEL_EVENT_ID);
                }, function () {
                    _this.props.engine.toggleOverlay(false, _this.SHORTENED_MODEL_EVENT_ID);
                    _this.logError(new Error("Convenience API error(getAnnualVehicleShortenedModelDetails)"));
                });
                this.setState({
                    subscription: sub,
                });
            }
            else {
                this.setState({
                    vehicleShortenedModelList: [],
                    shortenedModelReadOnly: false,
                    shortenedModelValid: this.IS_VALID,
                });
            }
            this.props.engine.toggleOverlay(false, this.SHORTENED_MODEL_EVENT_ID);
        }
        else {
            this.props.engine.toggleOverlay(false, this.SHORTENED_MODEL_EVENT_ID);
        }
    };
    AnnualVehicleEditorWidget.prototype.handleManufacturerChange = function (event) {
        var _this = this;
        var vehicleManufacturer = (event.target.validity.valid) ? event.target.value : this.state.fullVehicleManufacturer;
        if (this.state.typingTimeout) {
            clearTimeout(this.state.typingTimeout);
        }
        this.setState({
            fullVehicleManufacturer: vehicleManufacturer,
            vehicleTransmissions: [],
            selectedVehicleTransmission: "",
            vehicleFuelTypes: [],
            selectedVehicleFuelType: "",
            doors: [],
            selectedDoors: "",
            fullVehicleModel: '',
            fullVehicleModelYear: '',
            typingTimeout: setTimeout(function () {
                _this.findVehicleManufacturer();
            }, this.props.question.settings.timeout),
            modelReadOnly: true,
            modelYearReadOnly: false,
            shortenedModelReadOnly: true,
            manufacturerValid: vehicleManufacturer.length > 0 ? this.IS_VALID : this.IS_INVALID,
            shortenedModelValid: "",
            // reset shortened model input field
            vehicleShortenedModelList: [],
            shortenedModelFound: "",
            fullVehicleShortenedModel: "",
        });
    };
    AnnualVehicleEditorWidget.prototype.handleModelChange = function (event) {
        var _this = this;
        var vehicleModel = (event.target.validity.valid) ? event.target.value : this.state.fullVehicleModel;
        if (this.state.typingTimeout) {
            clearTimeout(this.state.typingTimeout);
        }
        this.setState({
            fullVehicleModel: vehicleModel,
            typingTimeout: setTimeout(function () {
                _this.findVehicleModel();
            }, this.props.question.settings.timeout),
            modelValid: vehicleModel.length > 0 ? this.IS_VALID : this.IS_INVALID
        });
    };
    AnnualVehicleEditorWidget.prototype.handleShortenedModelChange = function (event) {
        var _this = this;
        var shortenedVehicleModel = (event.target.validity.valid) ? event.target.value : this.state.fullVehicleShortenedModel;
        if (this.state.typingTimeout) {
            clearTimeout(this.state.typingTimeout);
        }
        this.setState({
            fullVehicleShortenedModel: shortenedVehicleModel,
            typingTimeout: setTimeout(function () {
                _this.findVehicleShortenedModels(true);
            }, this.props.question.settings.timeout),
            shortenedModelValid: shortenedVehicleModel.length > 0 ? this.IS_VALID : this.IS_INVALID,
            fullVehicleModel: "",
            modelValid: "",
            modelReadOnly: true
        });
    };
    AnnualVehicleEditorWidget.prototype.handleModelYearChange = function (event) {
        var manufacturer = this.state.fullVehicleManufacturer ? this.state.fullVehicleManufacturer : "";
        this.interactionVehicle.year = event.target.value;
        this.props.onStateChange("".concat(this.props.question.settings.interactionVehicle), this.interactionVehicle);
        this.setState({
            fullVehicleModel: "",
            vehicleModelList: [],
            vehicleTransmissions: [],
            selectedVehicleTransmission: "",
            vehicleFuelTypes: [],
            selectedVehicleFuelType: "",
            doors: [],
            selectedDoors: "",
            fullVehicleModelYear: event.target.value,
            modelYearValid: event.target.value ? this.IS_VALID : this.IS_INVALID,
            modelReadOnly: true,
            modelValid: "",
            shortenedModelValid: ""
        });
        this.changelogRecorder.record(this.props.engine.getInteraction(), "change", this.props.question.settings.interactionVehicle, this.props.page && this.props.page.pageId);
        this.findVehicleTransmissions(manufacturer, this.state.fullVehicleShortenedModel, parseInt(event.target.value, 10));
    };
    AnnualVehicleEditorWidget.prototype.onSelectVehicleManufacturer = function (event) {
        var vehicleManufacturerDetails = this.state.vehicleManufacturerList[event.target.dataset.id];
        this.interactionVehicle.make = vehicleManufacturerDetails;
        this.props.onStateChange("".concat(this.props.question.settings.interactionVehicle), this.interactionVehicle);
        this.setState({
            fullVehicleManufacturer: event.target.textContent,
            vehicleManufacturerList: []
        });
        this.setState({
            shortenedModelReadOnly: false
        });
        this.changelogRecorder.record(this.props.engine.getInteraction(), "change", this.props.question.settings.interactionVehicle, this.props.page && this.props.page.pageId);
    };
    AnnualVehicleEditorWidget.prototype.onSelectVehicleTransmission = function (event) {
        var newValue = event.target.value;
        var manufacturer = this.state.fullVehicleManufacturer ? this.state.fullVehicleManufacturer : "";
        var year = this.state.fullVehicleModelYear ? parseInt(this.state.fullVehicleModelYear, 10) : 0;
        this.props.onStateChange("".concat(this.props.question.settings.interactionVehicle), this.interactionVehicle);
        this.changelogRecorder.record(this.props.engine.getInteraction(), "change", this.props.question.settings.interactionVehicle, this.props.page && this.props.page.pageId);
        this.setState({
            fullVehicleModel: "",
            vehicleModelList: [],
            vehicleFuelTypes: [],
            doors: [],
            selectedDoors: "",
            selectedVehicleFuelType: "",
            selectedVehicleTransmission: newValue,
            modelReadOnly: true,
            modelValid: "",
            shortenedModelValid: ""
        });
        this.findVehicleFuelTypes(manufacturer, this.state.fullVehicleShortenedModel, year, newValue, true);
    };
    AnnualVehicleEditorWidget.prototype.onSelectVehicleFuelType = function (event) {
        var newValue = event.target.value;
        var manufacturer = this.state.fullVehicleManufacturer ? this.state.fullVehicleManufacturer : "";
        var year = this.state.fullVehicleModelYear ? parseInt(this.state.fullVehicleModelYear, 10) : 0;
        var transmission = this.state.selectedVehicleTransmission ? this.state.selectedVehicleTransmission : "";
        var shortenedModel = this.state.fullVehicleShortenedModel ? this.state.fullVehicleShortenedModel : "";
        this.interactionVehicle.fuelType = newValue;
        this.props.onStateChange("".concat(this.props.question.settings.interactionVehicle), this.interactionVehicle);
        this.setState({
            selectedVehicleFuelType: newValue,
            doors: [],
            selectedDoors: "",
            fullVehicleModel: "",
            vehicleModelList: [],
            modelReadOnly: false,
        });
        this.changelogRecorder.record(this.props.engine.getInteraction(), "change", this.props.question.settings.interactionVehicleFuelType, this.props.page && this.props.page.pageId);
        this.findVehicleNumberOfDoors(manufacturer, shortenedModel, year, transmission, newValue);
    };
    AnnualVehicleEditorWidget.prototype.onSelectNumberOfDoors = function (event) {
        var value = event.target.value;
        this.interactionVehicle.doors = value;
        this.props.onStateChange("".concat(this.props.question.settings.interactionVehicle), this.interactionVehicle);
        this.setState({
            selectedDoors: value,
            fullVehicleModel: "",
            vehicleModelList: [],
            modelReadOnly: false,
            doorsValid: value ? this.IS_VALID : this.IS_INVALID
        });
        this.changelogRecorder.record(this.props.engine.getInteraction(), "change", this.props.question.settings.interactionVehicle, this.props.page && this.props.page.pageId);
    };
    AnnualVehicleEditorWidget.prototype.onKeyPressVehicleManufacturer = function (event) {
        var activeEl = document.activeElement;
        if (event.key === "Enter") {
            this.onSelectVehicleManufacturer(event);
        }
        else if (event.key === "ArrowDown" && activeEl && activeEl.nextElementSibling && activeEl.nextElementSibling instanceof HTMLElement) {
            activeEl.nextElementSibling.focus();
        }
        else if (event.key === "ArrowUp" && activeEl && activeEl.previousElementSibling && activeEl.previousElementSibling instanceof HTMLElement) {
            activeEl.previousElementSibling.focus();
        }
    };
    AnnualVehicleEditorWidget.prototype.onSelectVehicleModel = function (event) {
        var vehicleModelDetails = this.state.vehicleModelList[event.target.dataset.id];
        this.interactionVehicle.model = vehicleModelDetails['model'];
        this.interactionVehicle.fuelTypeFull = vehicleModelDetails['fuelTypeFull'];
        this.interactionVehicle.engineSize = vehicleModelDetails['engineCapacity'];
        this.interactionVehicle.bodyStyle = vehicleModelDetails['bodyStyle'];
        this.interactionVehicle.transmission = vehicleModelDetails['transmissionCode'];
        this.props.onStateChange("".concat(this.props.question.settings.interactionVehicle), this.interactionVehicle);
        if (this.state.vehicleModelList.filter(function (vehicleModel) { return vehicleModel.model === vehicleModelDetails.model; }).length > 1) {
            this.props.onStateChange("uistate.maxCarYear", vehicleModelDetails['yearMax']);
            this.props.onStateChange("uistate.minCarYear", vehicleModelDetails['yearMin']);
        }
        else {
            this.props.onStateChange("uistate.maxCarYear", null);
            this.props.onStateChange("uistate.minCarYear", null);
        }
        this.setState({
            fullVehicleModel: event.target.textContent,
            vehicleModelList: [],
            vehicleShortenedModelList: [],
            modelYearReadOnly: false,
            shortenedModelReadOnly: false
        });
        this.changelogRecorder.record(this.props.engine.getInteraction(), "change", this.props.question.settings.interactionVehicle, this.props.page && this.props.page.pageId);
    };
    AnnualVehicleEditorWidget.prototype.onSelectVehicleShortenedModel = function (event) {
        this.interactionVehicle.shortenedModel = this.state.vehicleShortenedModelList[event.target.dataset.id];
        this.setState({
            fullVehicleModel: "",
            fullVehicleShortenedModel: event.target.textContent,
            modelReadOnly: false,
            vehicleModelList: [],
            vehicleShortenedModelList: [],
            shortenedModelValid: event.target.textContent.length > 0 ? this.IS_VALID : this.IS_INVALID
        });
        this.changelogRecorder.record(this.props.engine.getInteraction(), "change", this.props.question.settings.interactionVehicle, this.props.page && this.props.page.pageId);
        this.findVehicleModelYear(this.state.fullVehicleManufacturer, event.target.textContent, true);
    };
    AnnualVehicleEditorWidget.prototype.onKeyPressVehicleModel = function (event, fullModel) {
        var activeEl = document.activeElement;
        if (event.key === "Enter") {
            if (fullModel) {
                this.onSelectVehicleModel(event);
            }
            else {
                this.onSelectVehicleShortenedModel(event);
            }
        }
        else if (event.key === "ArrowDown" && activeEl && activeEl.nextElementSibling && activeEl.nextElementSibling instanceof HTMLElement) {
            activeEl.nextElementSibling.focus();
        }
        else if (event.key === "ArrowUp" && activeEl && activeEl.previousElementSibling && activeEl.previousElementSibling instanceof HTMLElement) {
            activeEl.previousElementSibling.focus();
        }
    };
    AnnualVehicleEditorWidget.prototype.isFieldValidAndFound = function (stateFieldValid, stateFieldFound) {
        if (stateFieldValid === this.IS_VALID && stateFieldFound === this.IS_VALID) {
            return this.IS_VALID;
        }
        else if (stateFieldValid === this.IS_INVALID || stateFieldFound === this.IS_INVALID) {
            return this.IS_INVALID;
        }
        return "";
    };
    AnnualVehicleEditorWidget.prototype.isFieldValid = function (stateField) {
        if (stateField === this.IS_VALID) {
            return this.IS_VALID;
        }
        else if (stateField === this.IS_INVALID) {
            return this.IS_INVALID;
        }
        return "";
    };
    AnnualVehicleEditorWidget.prototype.isFieldLoading = function (loading) {
        return loading ? 'loading-input' : '';
    };
    AnnualVehicleEditorWidget.prototype.handleOnPurchaseMonthChange = function (event) {
        var purchaseDateMonth = (event.target.validity.valid) ? event.target.value : this.state.purchaseDateMonth;
        this.setState({ purchaseDateMonth: purchaseDateMonth });
    };
    AnnualVehicleEditorWidget.prototype.handleOnPurchaseYearChange = function (event) {
        var purchaseDateYear = event.target.validity.valid ? event.target.value : this.state.purchaseDateYear;
        this.setState({ purchaseDateYear: purchaseDateYear });
    };
    AnnualVehicleEditorWidget.prototype.handleOnCheckboxChange = function (event) {
        var _a;
        var hasNotBeenBought = event.target.validity.valid ? event.target.checked : this.state.hasNotBeenBought;
        this.interactionVehicle.hasNotBeenBought = hasNotBeenBought;
        this.props.onStateChange("".concat(this.props.question.settings.interactionVehicle), this.interactionVehicle);
        this.props.engine.setJourneyState((_a = {}, _a["hidePageValidationErrorMessage"] = hasNotBeenBought, _a));
        if (hasNotBeenBought) {
            this.setState({ purchaseDateYear: null, purchaseDateMonth: null, purchaseMonthValid: "", purchaseYearValid: "" });
        }
        this.setState({ hasNotBeenBought: hasNotBeenBought });
        this.props.interaction.vehicles[0].purchaseDatePopulated = !!(this.state.purchaseMonthValid === this.IS_VALID && this.state.purchaseYearValid === this.IS_VALID || hasNotBeenBought);
    };
    AnnualVehicleEditorWidget.prototype.bindPurchaseDateToField = function () {
        var monthNumber = parseInt(this.state.purchaseDateMonth, 10);
        var validated = false;
        if (isNaN(monthNumber) || monthNumber < 1 || monthNumber > 12 || this.state.purchaseDateMonth.length !== 2) {
            this.purchaseDateErrorMessage = "Date is not valid. Example: 01/2019.";
            this.setState({
                purchaseMonthValid: this.IS_INVALID,
                fullVehiclePurchaseDate: undefined,
                purchaseYearValid: this.state.purchaseDateYear ? this.IS_VALID : this.IS_INVALID
            });
        }
        else {
            var purchaseDateString = "".concat(this.state.purchaseDateYear, "-").concat(this.state.purchaseDateMonth, "-01");
            var purchaseDate = moment(purchaseDateString);
            if (this.state.fullVehicleModelYear && this.state.purchaseDateYear) {
                validated = (this.state.purchaseDateYear >= this.state.fullVehicleModelYear && purchaseDate.isSameOrBefore(moment(), 'month'));
            }
            if (validated) {
                this.interactionVehicle.purchaseDate = purchaseDateString;
                this.props.onStateChange("".concat(this.props.question.settings.interactionVehicle), this.interactionVehicle);
                this.setState({
                    purchaseMonthValid: this.IS_VALID,
                    purchaseYearValid: this.IS_VALID,
                    fullVehiclePurchaseDate: purchaseDateString
                });
            }
            else {
                this.setState({
                    purchaseYearValid: this.IS_INVALID,
                    fullVehiclePurchaseDate: undefined
                });
                if (!this.state.purchaseDateYear) {
                    this.purchaseDateErrorMessage = "Purchase date is mandatory";
                }
                else {
                    purchaseDate.isAfter(moment(), 'month') ?
                        this.purchaseDateErrorMessage = "Purchase date cannot be this far in the future" :
                        this.purchaseDateErrorMessage = "Purchase date cannot be earlier than vehicle year of manufacture";
                }
            }
        }
        this.props.interaction.vehicles[0].purchaseDatePopulated = validated || this.state.hasNotBeenBought;
    };
    AnnualVehicleEditorWidget.prototype.renderFoundVehicleManufacturers = function () {
        var _this = this;
        var vehicleManufacturers = [];
        if (this.state.vehicleManufacturerList && this.state.vehicleManufacturerList.length > 0) {
            var index_1 = 0;
            this.state.vehicleManufacturerList.forEach(function (vehicleManufacturer) {
                vehicleManufacturers.push(React.createElement("li", { onClick: _this.onSelectVehicleManufacturer, onKeyDown: _this.onKeyPressVehicleManufacturer, key: index_1, "data-id": index_1, tabIndex: 0 }, vehicleManufacturer));
                index_1++;
            });
            return (React.createElement("div", { className: "addressLookupWrapper" },
                React.createElement("ul", { className: "addressesFound" }, vehicleManufacturers)));
        }
        else {
            return null;
        }
    };
    AnnualVehicleEditorWidget.prototype.renderVehicleManufacturers = function () {
        return (React.createElement("div", { className: "addressLookup margin-bottom-30 w-100" },
            React.createElement("input", { type: "text", className: "form-control ".concat(this.isFieldLoading(this.state.manufacturerLoading), " ").concat(this.isFieldValidAndFound(this.state.manufacturerValid, this.state.manufacturerFound)), id: "vehicle-make", "aria-describedby": "makeDescription", value: this.state.fullVehicleManufacturer, onChange: this.handleManufacturerChange, placeholder: "Start typing the make of your vehicle...", autoComplete: "off" }),
            React.createElement("div", { id: "makeDescription", "aria-label": this.ariaSuggestionsAvailableString(this.state.vehicleManufacturerList) }),
            this.renderFoundVehicleManufacturers(),
            this.state.manufacturerValid === this.IS_INVALID &&
                React.createElement("div", { className: "invalid-feedback d-block" }, "Make is mandatory."),
            this.state.manufacturerFound === this.IS_INVALID &&
                React.createElement("div", { className: "invalid-feedback d-block" }, "Make not found. Please refine your criteria.")));
    };
    AnnualVehicleEditorWidget.prototype.renderVehicleManufactureYears = function () {
        var vehicleModelYearsToRender = [];
        if (this.state.vehicleModelYears && this.state.vehicleModelYears.length > 0) {
            var yearFrom = this.state.vehicleModelYears[0].yearMin;
            var yearTo = this.state.vehicleModelYears[0].yearMax;
            if (yearFrom && yearTo) {
                var yearsTotal = yearTo - yearFrom;
                for (var i = 0; i <= yearsTotal; i++) {
                    vehicleModelYearsToRender.push(React.createElement("option", { key: i, value: yearTo - i }, yearTo - i));
                }
            }
        }
        if (this.state.fullVehicleShortenedModel) {
            return (React.createElement(React.Fragment, null,
                React.createElement("label", { className: "mt-3 margin-top-30" }, "Year of manufacture"),
                React.createElement("div", { className: "input-group margin-bottom-30", "aria-live": "assertive" },
                    React.createElement("select", { value: this.state.fullVehicleModelYear, className: "form-control form-radius ".concat(this.isFieldLoading(this.state.modelYearLoading), " ").concat(this.isFieldValid(this.state.modelYearValid)), id: "vehicle-manufacture-year", "aria-describedby": "modelYarDescription", onChange: this.handleModelYearChange, disabled: this.state.modelYearReadOnly },
                        React.createElement("option", { value: '' }, "Please select..."),
                        vehicleModelYearsToRender),
                    React.createElement("div", { id: "modelYarDescription", "aria-label": this.ariaSuggestionsAvailableString(vehicleModelYearsToRender) }),
                    this.state.modelYearValid === this.IS_INVALID &&
                        React.createElement("div", { className: "invalid-feedback d-block" }, "Year is mandatory."))));
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    AnnualVehicleEditorWidget.prototype.renderVehiclePurchaseDate = function () {
        if (this.state.fullVehicleModelYear && this.state.fullVehicleManufacturer) {
            return (React.createElement(React.Fragment, null,
                React.createElement("label", { className: "mt-3 margin-top-30" }, "Date of purchase"),
                React.createElement("div", { className: "input-group" },
                    !this.state.hasNotBeenBought &&
                        React.createElement("div", { className: "customDate-container" },
                            React.createElement("div", { className: "custom-month" },
                                "Month",
                                React.createElement("br", null),
                                React.createElement("input", { type: "text", className: "form-control customDate-month ".concat(this.isFieldValid(this.state.purchaseMonthValid)), value: this.state.purchaseDateMonth, "aria-label": "Purchase month input field", onChange: this.handleOnPurchaseMonthChange, onBlur: this.bindPurchaseDateToField, placeholder: "MM", pattern: "[0-9]*", maxLength: 2, disabled: !this.state.fullVehicleModelYear, id: "purchase-date-month" })),
                            React.createElement("div", { className: "custom-month" },
                                "Year",
                                React.createElement("br", null),
                                React.createElement("input", { type: "text", className: "form-control customDate-year ".concat(this.isFieldValid(this.state.purchaseYearValid)), value: this.state.purchaseDateYear, "aria-label": "Purchase year input field", onChange: this.handleOnPurchaseYearChange, onBlur: this.bindPurchaseDateToField, placeholder: "YYYY", pattern: "[0-9]*", maxLength: 4, disabled: !this.state.fullVehicleModelYear, id: "purchase-date-year" }))),
                    (this.state.purchaseMonthValid === this.IS_INVALID || this.state.purchaseYearValid === this.IS_INVALID) && !this.state.hasNotBeenBought
                        && React.createElement("div", { className: "invalid-feedback d-block" }, this.purchaseDateErrorMessage)),
                React.createElement("div", { className: "falcon-checkbox form-group mt-3 margin-bottom-30", style: { marginLeft: "20px" } },
                    React.createElement("div", { className: "d-flex width-450" },
                        React.createElement("div", { className: "form-check mr-3" },
                            React.createElement("input", { className: "custom-control-input true", onChange: this.handleOnCheckboxChange, type: "checkbox", "aria-label": "The car hasn't been bought yet", id: "notBeenBoughtCheckbox", checked: this.state.hasNotBeenBought }),
                            React.createElement("label", { className: "custom-control-label", htmlFor: "notBeenBoughtCheckbox" },
                                React.createElement("div", { className: "checkbox-big" }),
                                React.createElement("div", { className: "checkbox-label" },
                                    React.createElement("p", null, "The car hasn't been bought yet"))))))));
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    AnnualVehicleEditorWidget.prototype.renderTransmissionRadioButtons = function () {
        var _this = this;
        var radioButtons = [];
        var transmissionMap = new Map([
            ["M", { label: "Manual", otherKeys: ["M"] }],
            ["A", { label: "Automatic", otherKeys: ["A", "SA", "CVT"] }], // Automatic includes also Semi-auto (SA) and CVT
        ]);
        var supportedTransmissionCodes = ["M", "A", "SA", "CVT"];
        transmissionMap.forEach(function (value, key) {
            if ((0, commonFunctions_1.arraysIntersect)(_this.state.vehicleTransmissions, value.otherKeys)) {
                radioButtons.push(React.createElement("div", { className: "custom-control custom-radio" },
                    React.createElement("input", { className: "custom-control-input vehicle-details-radio " + _this.state.transmissionValid, type: "radio", name: "vehicleTransmission" + key, id: "vehicleTransmission" + key, value: key, checked: (0, commonFunctions_1.arraysIntersect)([_this.state.selectedVehicleTransmission], value.otherKeys), disabled: !(0, commonFunctions_1.arraysIntersect)(_this.state.vehicleTransmissions, supportedTransmissionCodes), onChange: _this.onSelectVehicleTransmission }),
                    React.createElement("label", { className: "custom-control-label", htmlFor: "vehicleTransmission" + key }, value.label)));
            }
        });
        if ((this.props.interaction.vehicles[0].purchaseDatePopulated && this.props.interaction.vehicles[0].purchaseDatePopulated == true
            && this.state.fullVehicleModelYear && this.state.fullVehicleManufacturer)
            || this.state.hasNotBeenBought || this.state.transmissionValid || this.state.selectedVehicleTransmission) {
            return (React.createElement("div", { className: "form-group margin-bottom-30 margin-top-30" },
                React.createElement("label", { className: "mt-3 margin-top-0" }, "Transmission"),
                React.createElement("div", { className: "mt-3 mb-3" }, "If the car is semi-automatic or CVT (Continuously Variable Transmission) select 'Automatic\u2019"),
                React.createElement("div", { className: "input-group width-450 edit-vehicle-transmission", role: "group", "aria-label": "Transmission" }, radioButtons),
                this.state.transmissionValid === this.IS_INVALID &&
                    React.createElement("div", { className: "invalid-feedback d-block" }, "Please answer this to carry on")));
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    AnnualVehicleEditorWidget.prototype.renderFuelTypeRadioButtons = function () {
        var _this = this;
        var radioButtons = [];
        var fuelTypeMap = new Map([
            ["Petrol", "P"],
            ["Diesel", "D"],
            ["Hybrid", "H"],
            ["Electric", "E"]
        ]);
        fuelTypeMap.forEach(function (key, value) {
            if (_this.state.vehicleFuelTypes.includes(key)) {
                radioButtons.push(React.createElement("div", { className: "custom-control custom-radio" },
                    React.createElement("input", { className: "custom-control-input vehicle-details-radio" + _this.state.fuelTypeValid, type: "radio", name: "vehicleFuelType" + key, id: "vehicleFuelType" + key, value: key, checked: _this.state.selectedVehicleFuelType === key, disabled: !_this.state.vehicleFuelTypes.includes(key), onChange: _this.onSelectVehicleFuelType }),
                    React.createElement("label", { className: "custom-control-label", htmlFor: "vehicleFuelType" + key }, value)));
            }
        });
        if (this.state.selectedVehicleTransmission) {
            return (React.createElement("div", { className: "form-group margin-bottom-30 margin-top-30" },
                React.createElement("label", { className: "mt-3 margin-top-0" }, "Fuel type"),
                React.createElement("div", { className: "input-group width-450 fuel-type", role: "group", "aria-label": "Fuel type" }, radioButtons),
                this.state.fuelTypeValid === this.IS_INVALID &&
                    React.createElement("div", { className: "invalid-feedback d-block" }, "Please answer this to carry on")));
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    AnnualVehicleEditorWidget.prototype.renderNumberOfDoors = function () {
        var options = [];
        this.state.doors.forEach(function (noOfDoors, index) {
            options.push(React.createElement("option", { key: index, value: noOfDoors }, noOfDoors));
        });
        if (this.state.selectedVehicleFuelType) {
            return (React.createElement(React.Fragment, null,
                React.createElement("label", { className: "mt-3 margin-top-30" }, "Number of doors"),
                React.createElement("div", { className: "input-group margin-bottom-30", "aria-live": "assertive" },
                    React.createElement("select", { value: this.state.selectedDoors, className: "form-control form-radius " + this.state.doorsValid, id: "vehicle-doors", "aria-describedby": "doors-description", onChange: this.onSelectNumberOfDoors, disabled: false },
                        React.createElement("option", { value: '' }, "Please select..."),
                        options),
                    React.createElement("div", { id: "doors-description", "aria-label": this.ariaSuggestionsAvailableString(this.state.doors) })),
                this.state.doorsValid === "is-invalid" &&
                    React.createElement("div", { className: "invalid-feedback d-block" }, "Number of doors is mandatory.")));
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    AnnualVehicleEditorWidget.prototype.renderFoundVehicleModels = function () {
        var _this = this;
        var vehicleModels = [];
        if (this.state.vehicleModelList && this.state.vehicleModelList.length > 0) {
            var index_2 = 0;
            // Somewhat efficient way to find duplicate of vehicle model
            // Idea was taken from https://stackoverflow.com/questions/53212020/get-list-of-duplicate-objects-in-an-array-of-objects#answer-53212154
            // We go through list of models and if we meet that model first time - we populate object with key: modelName, value:0 if second time key: modelName, value: {previousValue + 1}
            var objectWithValuesCount_1 = this.state.vehicleModelList.reduce(function (a, vehicleModel) {
                if (vehicleModel.model) {
                    a[vehicleModel.model] = ++a[vehicleModel.model] || 0;
                }
                return a;
            }, {});
            this.state.vehicleModelList.forEach(function (vehicleModel) {
                var fullVehicleModel;
                if (vehicleModel.model && objectWithValuesCount_1[vehicleModel.model]) {
                    fullVehicleModel = _this.getFullVehicleModelWithYearsString(vehicleModel);
                }
                else {
                    fullVehicleModel = _this.getFullVehicleModelString(vehicleModel);
                }
                vehicleModels.push(React.createElement("li", { onClick: _this.onSelectVehicleModel, onKeyDown: function () { return _this.onKeyPressVehicleModel(_this, true); }, key: index_2, "data-id": index_2, tabIndex: 0 }, fullVehicleModel));
                index_2++;
            });
            return (React.createElement("div", { className: "addressLookupWrapper" },
                React.createElement("ul", { className: "addressesFound" }, vehicleModels)));
        }
        else {
            return null;
        }
    };
    AnnualVehicleEditorWidget.prototype.renderFoundVehicleShortenedModels = function () {
        var _this = this;
        var vehicleShortenedModels = [];
        if (this.state.vehicleShortenedModelList && this.state.vehicleShortenedModelList.length > 0) {
            var index_3 = 0;
            this.state.vehicleShortenedModelList.forEach(function (shortenedModel) {
                vehicleShortenedModels.push(React.createElement("li", { onClick: _this.onSelectVehicleShortenedModel, onKeyDown: function () { return _this.onKeyPressVehicleModel(_this, false); }, key: index_3, "data-id": index_3, tabIndex: 0 }, shortenedModel));
                index_3++;
            });
            return (React.createElement("div", { className: "addressLookupWrapper" },
                React.createElement("ul", { className: "addressesFound" }, vehicleShortenedModels)));
        }
        else {
            return null;
        }
    };
    AnnualVehicleEditorWidget.prototype.renderVehicleShortenedModelQuestion = function () {
        if (this.state.fullVehicleManufacturer) {
            return (React.createElement(React.Fragment, null,
                React.createElement("label", { className: "mt-3 margin-top-30" }, "Car model"),
                React.createElement("div", { className: "addressLookup margin-bottom-30 w-100" },
                    React.createElement("input", { type: "text", className: "form-control ".concat(this.isFieldLoading(this.state.manufacturerLoading), " ").concat(this.isFieldValidAndFound(this.state.shortenedModelValid, this.state.shortenedModelFound)), id: "vehicle-shortened-model", "aria-describedby": "shortenedModelDescription", value: this.state.fullVehicleShortenedModel, onChange: this.handleShortenedModelChange, onClick: this.loadShortenedModelsOnFirstClick, readOnly: this.state.shortenedModelReadOnly, placeholder: "Start typing the model name of your vehicle...", autoComplete: "off" }),
                    React.createElement("div", { id: "modelDescription", "aria-label": this.ariaSuggestionsAvailableString(this.state.vehicleModelList) }),
                    this.renderFoundVehicleShortenedModels(),
                    this.state.shortenedModelValid === this.IS_INVALID &&
                        React.createElement("div", { className: "invalid-feedback d-block" }, "Model is mandatory."),
                    this.state.shortenedModelFound === this.IS_INVALID &&
                        React.createElement("div", { className: "invalid-feedback d-block" }, "Model not found. Please refine your criteria."))));
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    AnnualVehicleEditorWidget.prototype.renderVehicleModelQuestion = function () {
        if (this.state.selectedDoors) {
            return (React.createElement(React.Fragment, null,
                React.createElement("label", { className: "mt-3 margin-top-30" }, "Select the car"),
                React.createElement("div", { className: "addressLookup margin-bottom-30 w-100" },
                    React.createElement("input", { type: "text", className: "form-control ".concat(this.isFieldLoading(this.state.modelLoading), " ").concat(this.isFieldValidAndFound(this.state.modelValid, this.state.modelFound)), id: "vehicle-model", "aria-describedby": "modelDescription", value: this.state.fullVehicleModel, onChange: this.handleModelChange, onClick: this.loadModelsOnFirstClick, readOnly: this.state.modelReadOnly, placeholder: "Start typing the model name of your vehicle...", autoComplete: "off" }),
                    React.createElement("div", { id: "modelDescription", "aria-label": this.ariaSuggestionsAvailableString(this.state.vehicleModelList) }),
                    this.renderFoundVehicleModels(),
                    this.state.modelValid === this.IS_INVALID &&
                        React.createElement("div", { className: "invalid-feedback d-block" }, "Model is mandatory."),
                    this.state.modelFound === this.IS_INVALID &&
                        React.createElement("div", { className: "invalid-feedback d-block" }, "Model not found. Please refine your criteria."))));
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    AnnualVehicleEditorWidget.prototype.getFullVehicleModelString = function (vehicleModelDetails) {
        return vehicleModelDetails.displayModel ? vehicleModelDetails.displayModel : '';
    };
    AnnualVehicleEditorWidget.prototype.getFullVehicleModelWithYearsString = function (vehicleModelDetails) {
        if (!vehicleModelDetails.displayModel)
            return '';
        return vehicleModelDetails.displayModel + " (" + vehicleModelDetails.yearMin + " - " + (vehicleModelDetails.yearMax || "...") + ")";
    };
    AnnualVehicleEditorWidget.prototype.ariaSuggestionsAvailableString = function (array) {
        var defaultSTR = "Suggestion size ";
        if (array && array.length > 0) {
            return defaultSTR + array.length;
        }
        else {
            return '';
        }
    };
    AnnualVehicleEditorWidget.prototype.allFieldsFilled = function () {
        var manufacturer = this.state.fullVehicleManufacturer;
        var makeYear = this.state.fullVehicleModelYear;
        var purchaseYear = this.state.fullVehiclePurchaseDate || this.state.hasNotBeenBought;
        var transmission = this.state.selectedVehicleTransmission;
        var fuelType = this.state.selectedVehicleFuelType;
        var numberOfDoors = this.state.selectedDoors;
        var shortenedModel = this.state.fullVehicleShortenedModel;
        var model = this.state.fullVehicleModel;
        return !(!manufacturer || !makeYear || !purchaseYear || !transmission || !fuelType || !numberOfDoors || !shortenedModel || !model);
    };
    AnnualVehicleEditorWidget.prototype.navigate = function () {
        var vehicle = this.props.interaction.vehicles[0];
        if (vehicle.hasNotBeenBought) {
            vehicle.purchaseDate = undefined;
        }
        vehicle.manuallyChosen = true;
        this.executeEvent("change");
        this.props.engine.navigate("".concat(this.carDetailsPage), false);
    };
    AnnualVehicleEditorWidget.prototype.callVehicleModelService = function (update, manufacturer, model) {
        var _this = this;
        this.state.subscription.unsubscribe();
        var modelYear = parseInt(this.state.fullVehicleModelYear, 10);
        var numberOfDoors = parseInt(this.state.selectedDoors, 10);
        var shortenedModel = this.state.fullVehicleShortenedModel ? this.state.fullVehicleShortenedModel : "";
        if (modelYear) {
            var sub = this.falconConvenienceApiService.getAnnualVehicleModelDetails(manufacturer, modelYear, this.state.selectedVehicleTransmission, this.state.selectedVehicleFuelType, null, numberOfDoors, null, shortenedModel, model)
                .subscribe(function (output) {
                _this.setState({
                    vehicleModelList: output,
                    modelFound: output.length > 0 ? _this.IS_VALID : _this.IS_INVALID,
                    modelLoading: false
                });
            }, function () {
                _this.logError(new Error("Convenience API error(getVehicleModelDetails)"));
                _this.setState({
                    modelLoading: false
                });
            });
            this.setState({
                subscription: sub,
                modelLoading: update
            });
        }
        else {
            this.logError(new Error("Failed to parse model year form ".concat(this.state.fullVehicleModelYear)));
        }
    };
    AnnualVehicleEditorWidget.prototype.logError = function (error, errorInfo) {
        this.journeyRuntimeService.doBackendAction("log", this.props.interaction, {
            level: "ERROR",
            message: "VehicleModelLookupWidget exception: ".concat(error && error.message ? error.message : "", "\n                Interaction id: ").concat(this.props.interaction._id || "-", "\n                fullVehicleManufacturer: ").concat(this.state.fullVehicleManufacturer, "\n                fullVehicleModelYear: ").concat(this.state.fullVehicleModelYear, "\n                selectedVehicleTransmission: ").concat(this.state.selectedVehicleTransmission, "\n                selectedVehicleFuelType: ").concat(this.state.selectedVehicleFuelType, "\n               \"vehicleShortenedModel : ").concat(this.state.fullVehicleShortenedModel, "\n                fullVehicleModel: ").concat(this.state.fullVehicleModel, "\n                ComponentStack: ").concat(errorInfo && errorInfo.componentStack || "-", "\n                Stack: ").concat(error && error.stack || "-")
        }, false).subscribe();
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.FalconConvenienceApiService),
        __metadata("design:type", Object)
    ], AnnualVehicleEditorWidget.prototype, "falconConvenienceApiService", void 0);
    __decorate([
        (0, core_1.lazyInject)(plugin_journey_1.Types.JourneyRuntimeService),
        __metadata("design:type", Object)
    ], AnnualVehicleEditorWidget.prototype, "journeyRuntimeService", void 0);
    return AnnualVehicleEditorWidget;
}(FalconQuestionWidgetBase_1.FalconQuestionWidgetBase));
//# sourceMappingURL=AnnualVehicleEditorWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/AnnualVehicleEditorWidget.js
// module id = 3178
// module chunks = 0